import apiUrlConfig from 'configs/apiUrlConfig';
import AuthenticatedRequestService from 'services/requests/Authenticated';

const URLS = {
  CREATE: `${apiUrlConfig.apiEndPoint()}/businesses/:business_id/user_invitations`,
  INDEX: `${apiUrlConfig.apiEndPoint()}/businesses/:business_id/user_invitations`,
  RESEND: `${apiUrlConfig.apiEndPoint()}/user_invitations/:user_invitation_id/resend`,
  DELETE: `${apiUrlConfig.apiEndPoint()}/user_invitations/:user_invitation_id`,
  VALIDATE: `${apiUrlConfig.apiEndPoint()}/user_invitations/:user_invitation_id/validate`,
};

function insertUserInvitationIdToUrl(url, id) {
  return url.replace(':user_invitation_id', id);
}

function insertBusinessIdToUrl(url, id) {
  return url.replace(':business_id', id);
}

class BusinessUserInvitationApi {
  /**
   * send invitation to the business users
   */
  static addNew(email, role, businessId) {
    const CREATE_URL = insertBusinessIdToUrl(URLS.CREATE, businessId);
    const data = {
      user_invitation: {
        email,
        role,
      },
    };

    return AuthenticatedRequestService.post(CREATE_URL, data);
  }

  /**
   * validate user invitation
   */
  static validate(userInvitationId) {
    const VALIDATE_URL = insertUserInvitationIdToUrl(
      URLS.VALIDATE,
      userInvitationId
    );

    return AuthenticatedRequestService.get(VALIDATE_URL);
  }

  /**
   * show all user invitation
   */
  static getAll(businessId) {
    const INDEX_URL = insertBusinessIdToUrl(URLS.INDEX, businessId);

    return AuthenticatedRequestService.get(INDEX_URL);
  }

  /**
   * update user invitation
   */
  static resend(userInvitationId) {
    const RESEND_URL = insertUserInvitationIdToUrl(
      URLS.RESEND,
      userInvitationId
    );

    return AuthenticatedRequestService.get(RESEND_URL);
  }

  /**
   * delete user invitation
   */
  static delete(userInvitationId) {
    const DELETE_URL = insertUserInvitationIdToUrl(
      URLS.DELETE,
      userInvitationId
    );

    return AuthenticatedRequestService.delete(DELETE_URL);
  }
}

export default BusinessUserInvitationApi;



// WEBPACK FOOTER //
// ./src/apis/BusinessUserInvitation.js